var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('main',{staticClass:"p-4 pt-14 lg:pt-24 min-h-screen"},[_c('k-layout',{attrs:{"content":_vm.page.layout}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }